import type { KanbanComment } from '@entities/kanban-comment'

import { useKanbanCommentsStore } from '@entities/kanban-comment'
import { useCommonStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

interface SaveCommentResponse {
  stage_comment: KanbanComment
}

interface SaveCommentApiOptions {
  tutorId: string | number
  comment: string
  onStart?: () => void
  onSuccess?: (data: KanbanComment) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useSaveCommentApi = async (options: SaveCommentApiOptions): Promise<KanbanComment | null> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutor-kanban.comments', { tutor_id: options.tutorId })

  const kanbanCommentsStore = useKanbanCommentsStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.post(url!, { comment: options.comment })
    const response: SaveCommentResponse = data.data

    kanbanCommentsStore.addComment(response.stage_comment)
    commonStore.setLoading(false)

    options.onSuccess?.(response.stage_comment)

    return response.stage_comment
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options.onError?.(err)

    return null
  } finally {
    options.onFinish?.()
  }
}